<template>
  <div class="datamain">
    <Header />

    <div class="databox">
      <div class="top-filters" style="width: 100%; margin-bottom: 12px">
        <div
          style="
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 100%;
          "
        >
          <!-- 左侧：采收单操作按钮 -->
          <div style="display: flex; align-items: center; gap: 8px">
            <el-button
              v-if="getAllMenuCodes.includes('0I2QQ5wt')"
              type="primary"
              size="small"
              @click="handleOrderAdd"
            >
              <i class="el-icon-plus"></i> 新增
            </el-button>

            <el-button
              type="danger"
              size="small"
              :disabled="selectedOrderRows.length === 0"
              @click="handleOrderBatchDelete"
            >
              <i class="el-icon-delete"></i> 批量删除
            </el-button>
          </div>

          <!-- 右侧：采收单搜索项 -->
          <div style="display: flex; align-items: center; gap: 12px">
            <div class="time-label">所属大棚：</div>
            <el-select
              v-model="greenhouseId"
              placeholder="请选择"
              size="small"
              style="width: 140px"
              clearable
            >
              <el-option
                v-for="item in greenhouseOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>

            <div class="time-label">状态：</div>
            <el-select
              v-model="orderStatus"
              placeholder="全部"
              size="small"
              style="width: 120px"
              clearable
            >
              <el-option
                v-for="opt in orderStatusOptions"
                :key="opt.value"
                :label="opt.label"
                :value="opt.value"
              />
            </el-select>

            <div class="time-label">采收负责人：</div>
            <el-select
              v-model="harvestManagerId"
              placeholder="请选择"
              size="small"
              style="width: 140px"
              clearable
            >
              <el-option
                v-for="opt in harvestManagerOptions"
                :key="opt.value"
                :label="opt.label"
                :value="opt.value"
              />
            </el-select>

            <div class="time-label">采收日期：</div>
            <el-date-picker
              v-model="dateRange"
              type="daterange"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              size="small"
              value-format="yyyy-MM-dd"
            />
            <el-button type="primary" size="small" @click="onQuery"
              >查询</el-button
            >
            <el-button size="small" @click="onReset">刷新/重置</el-button>
          </div>
        </div>
      </div>

      <div class="table-wrap" style="width: 100%">
        <order-table
          :list="orderList"
          :page="orderPage"
          @selection-change="onOrderSelectionChange"
          @size-change="onOrderSizeChange"
          @current-change="onOrderPageChange"
          @view="viewOrder"
          @edit="editOrder"
          @add="handleOrderAdd"
          @batch-delete="handleOrderBatchDelete"
        />
      </div>
      <!-- 新增采收记录弹窗 -->
      <order-add-dialog
        :visible.sync="addDialogVisible"
        :greenhouse-options="greenhouseOptions"
        :harvest-manager-options="harvestManagerOptions"
        @success="onAddSuccess"
      />
      <!-- 查看采收记录弹窗 -->
      <order-view-dialog
        :visible.sync="viewDialogVisible"
        :order-id="currentOrderId"
        :greenhouse-options="greenhouseOptions"
        :harvest-manager-options="harvestManagerOptions"
      />
      <order-edit-dialog
        :visible.sync="editDialogVisible"
        :order-id="currentEditOrderId"
        :greenhouse-options="greenhouseOptions"
        :harvest-manager-options="harvestManagerOptions"
        @success="onEditSuccess"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import Header from "../../Header.vue";
import OrderTable from "./components/OrderTable.vue";
import OrderAddDialog from "./OrderAddDialog.vue";
import OrderViewDialog from "./OrderViewDialog.vue";
import OrderEditDialog from "./OrderEditDialog.vue";
import axios from "@/axios";
import { baseUrl } from "@/axios/baseUrl";
import dayjs from "dayjs";

export default {
  name: "HarvestAdd",
  components: {
    Header,
    OrderTable,
    // 弹窗：新增采收记录
    OrderAddDialog,
    // 弹窗：查看采收记录
    OrderViewDialog,
    // 弹窗：编辑采收记录
    OrderEditDialog,
  },
  computed: {
    ...mapGetters("user", ["getAllMenuCodes"]),
    ...mapState("user", ["userInfo"]),
  },
  data() {
    return {
      // filters
      dateRange: [],
      greenhouseId: "",
      greenhouseOptions: [],
      // order-specific filters
      orderStatus: "",
      orderStatusOptions: [
        { label: "草稿", value: "DRAFT" },
        { label: "待审核", value: "PENDING" },
        { label: "已审核", value: "REVIEWED" },
        { label: "已退回", value: "REJECTED" },
      ],
      harvestManagerId: "",
      harvestManagerOptions: [],

      // 采收单分页
      orderPage: {
        page: 1,
        pageSize: 10,
        totalCount: 0,
      },
      orderList: [],

      // selection state for orders (el-table rows)
      selectedOrderRows: [],
      // 新增弹窗可见性
      addDialogVisible: false,
      // 查看弹窗可见性
      viewDialogVisible: false,
      currentOrderId: null,
      // 编辑弹窗可见性
      editDialogVisible: false,
      currentEditOrderId: null,
    };
  },
  created() {
    this.getGreenhouseOptions();
    this.fetchUserList();
    this.fetchOrderPage();
  },
  methods: {
    // selection handlers for el-table
    onOrderSelectionChange(rows) {
      this.selectedOrderRows = Array.isArray(rows) ? rows : [];
    },

    // 打开新增采收记录弹窗
    handleOrderAdd() {
      this.addDialogVisible = true;
    },
    async handleOrderBatchDelete() {
      if (!this.selectedOrderRows.length) return;
      try {
        await this.$confirm(
          `确认删除选中的 ${this.selectedOrderRows.length} 条采收单?`,
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        );

        const ids = this.selectedOrderRows.map((r) => r.id);
        console.log("删除采收单 ids:", ids);

        // 调用批量删除接口
        const res = await axios.post(
          baseUrl + "/api/digital-farming/harvest/order-delete-batch",
          ids
        );

        if (res && res.code === 200) {
          this.$message &&
            this.$message.success &&
            this.$message.success("删除成功");
          // 清空选中状态
          this.selectedOrderRows = [];
          // 刷新列表
          this.fetchOrderPage();
        } else {
          throw new Error(res?.message || "删除失败");
        }
      } catch (error) {
        if (error !== "cancel") {
          console.error("删除采收单失败:", error);
          this.$message &&
            this.$message.error &&
            this.$message.error(error.message || "删除失败，请重试");
        }
      }
    },
    formatDate(v) {
      if (!v) return "";
      try {
        return dayjs(v).format("YYYY/MM/DD");
      } catch (e) {
        return v;
      }
    },
    mapStatus(s) {
      const map = {
        DRAFT: "草稿",
        PENDING: "待审核",
        REVIEWED: "已审核",
        REJECTED: "已退回",
      };
      return map[s] || s || "";
    },
    buildParams(page) {
      const params = {
        page: page.page,
        pageSize: page.pageSize,
      };
      if (this.greenhouseId) params.greenhouseId = this.greenhouseId;
      if (this.dateRange && this.dateRange.length === 2) {
        params.harvestDateStart = this.dateRange[0];
        params.harvestDateEnd = this.dateRange[1];
      }
      // 附加 order 筛选字段
      if (this.orderStatus) params.status = this.orderStatus;
      if (this.harvestManagerId)
        params.harvestManagerId = this.harvestManagerId;
      return params;
    },
    async fetchOrderPage() {
      try {
        const params = this.buildParams(this.orderPage);
        const res = await axios.post(
          baseUrl + "/api/digital-farming/harvest/order-page",
          params
        );
        if (res && res.code === 200 && res.data) {
          const d = res.data;
          console.log("ddd", d);

          this.orderPage.totalCount = parseInt(d.totalCount) || 0;
          this.orderPage.page = parseInt(d.page) || this.orderPage.page;
          this.orderPage.pageSize =
            parseInt(d.pageSize) || this.orderPage.pageSize;
          this.orderList = Array.isArray(d.list) ? d.list : [];
        }
      } catch (err) {
        console.error("fetchOrderPage error:", err);
      }
    },
    onQuery() {
      this.orderPage.page = 1;
      this.fetchOrderPage();
    },
    onReset() {
      this.dateRange = [];
      this.greenhouseId = "";
      this.orderStatus = "";
      this.harvestManagerId = "";
      this.orderPage.page = 1;
      this.fetchOrderPage();
    },
    onOrderPageChange(page) {
      this.orderPage.page = page;
      this.fetchOrderPage();
    },
    onOrderSizeChange(size) {
      this.orderPage.pageSize = size;
      this.orderPage.page = 1;
      this.fetchOrderPage();
    },
    viewOrder(item) {
      this.currentOrderId = item.id;
      this.viewDialogVisible = true;
    },
    editOrder(item) {
      // 检查是否可以编辑（草稿或已退回状态）
      if (item.status === "DRAFT" || item.status === "REJECTED") {
        this.currentEditOrderId = item.id;
        this.editDialogVisible = true;
      } else {
        this.$message &&
          this.$message.warning &&
          this.$message.warning("只有草稿和已退回状态的记录才能编辑");
      }
    },
    async getGreenhouseOptions() {
      try {
        const res = await axios.post(
          baseUrl + "/api/basic/greenhouse/selection"
        );
        if (res && res.code === 200 && Array.isArray(res.data)) {
          this.greenhouseOptions = res.data.map((it) => ({
            label: it.serialNumber || it.name || it.id,
            value: it.id,
          }));
        }
      } catch (err) {
        console.error("getGreenhouseOptions error:", err);
      }
    },
    async fetchUserList() {
      try {
        const res = await axios.post(baseUrl + "/api/system/user/page", {
          page: 1,
          pageSize: 288,
        });
        if (res.code === 200) {
          const users = res.data.list || [];
          console.log("获取的用户", users);

          this.harvestManagerOptions = users
            .filter(
              (user) =>
                user.roleCodes &&
                user.roleCodes.split(",").includes("greenhouse_admin")
            )
            .map((user) => ({
              label: user.nickName,
              value: user.id,
            }));

          // 如果当前用户不在采收负责人列表中，将其添加进去
          const currentUserExists = this.harvestManagerOptions.some(
            (option) => option.value === this.userInfo.userId
          );
          if (!currentUserExists && this.userInfo) {
            this.harvestManagerOptions.unshift({
              label:
                this.userInfo.nickName || this.userInfo.username || "当前用户",
              value: this.userInfo.userId,
            });
          }
        }
      } catch (error) {
        console.error("获取用户列表失败:", error);
      }
    },
    // 弹窗提交成功回调
    onAddSuccess() {
      this.fetchOrderPage();
    },
    // 编辑成功回调
    onEditSuccess() {
      this.fetchOrderPage();
    },
  },
};
</script>

<style scoped lang="less">
.simple-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 6px;
}
.simple-table th,
.simple-table td {
  padding: 10px 8px;
  border-bottom: 1px solid #eee;
  text-align: left;
  font-size: 14px;
  color: #333;
}
.simple-table thead th {
  background: #f5f7fa;
  color: #333;
  font-weight: 600;
}
.pagination-wrapper {
  display: flex;
  justify-content: flex-end;
  padding: 12px 0;
}
.databox {
  margin: 10px;
  width: calc(100% - 20px);
  height: calc(100% - 160px);
  background: rgba(0, 11, 47, 0.5);
  box-shadow: inset 0px 0px 20px 0px rgba(0, 124, 255, 0.5);
  border-radius: 0px 0px 0px 0px;
  padding: 10px;
  display: flex;
  flex-direction: column;
}

.top-filters {
  .time-label {
    margin-left: 0;
    color: #fff;
  }

  /* 响应式设计：在小屏幕上垂直排列 */
  @media (max-width: 1200px) {
    > div {
      flex-direction: column;
      align-items: flex-start !important;
      gap: 12px;

      > div {
        width: 100%;
        justify-content: flex-start;
      }
    }
  }

  /* 进一步的小屏幕优化 */
  @media (max-width: 768px) {
    .time-label {
      min-width: 80px;
    }
  }
}
</style>
